
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiLightLanternStbdColourOn as ObiLightLanternStbdColourOnElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-light-lantern-stbd-colour-on.js';
 
 
 

 
 export const ObiLightLanternStbdColourOn = createComponent({
   react: React,
   tagName: 'obi-light-lantern-stbd-colour-on',
   elementClass: ObiLightLanternStbdColourOnElement,
   events: {
     
   }
  });
 
 